import { Link } from 'react-router-dom'
import { Zap } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { planLimitVars, usePlanLimits } from '@/hooks/usePlanLimits'

export function UpgradeBanner() {
  const { t } = useTranslation()
  const limitVars = planLimitVars(usePlanLimits())

  return (
    <div className="mx-3 mb-2 rounded-lg bg-gradient-to-br from-primary/10 to-primary/5 border border-primary/20 p-3 space-y-2">
      <div className="flex items-center gap-1.5">
        <Zap className="h-3.5 w-3.5 text-primary" />
        <span className="text-xs font-semibold text-primary">{t('upgradeBanner.plan')}</span>
      </div>
      <p className="text-xs text-muted-foreground leading-snug">
        {t('upgradeBanner.description', limitVars)}
      </p>
      <Link
        to="/billing"
        className="block w-full rounded-md bg-primary px-2 py-1.5 text-center text-xs font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
      >
        {t('upgradeBanner.cta')}
      </Link>
    </div>
  )
}
